import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { CheckCircle, KeyRound } from 'lucide-react'
import { authApi } from '../../lib/api/auth'
import './auth.css'

export default function ResetPassword() {
  const [params] = useSearchParams()
  const navigate = useNavigate()

  const token = params.get('token') || ''
  const email = params.get('email') || ''

  const [password, setPassword] = useState('')
  const [confirm, setConfirm]   = useState('')
  const [loading, setLoading]   = useState(false)
  const [error, setError]       = useState('')
  const [done, setDone]         = useState(false)

  if (!token || !email) {
    return (
      <div className="forgot-page">
        <div className="forgot-wrapper">
          <div className="forgot-card forgot-success">
            <h2 style={{ color: 'var(--danger)' }}>Invalid Link</h2>
            <p>This password reset link is invalid or has already been used.</p>
            <Link to="/forgot-password" className="btn btn-primary" style={{ marginTop: 16, width: '100%', justifyContent: 'center' }}>
              Request a new link
            </Link>
          </div>
        </div>
      </div>
    )
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (password !== confirm) {
      setError('Passwords do not match.')
      return
    }
    setError('')
    setLoading(true)
    try {
      await authApi.resetPassword(token, email, password)
      setDone(true)
      setTimeout(() => navigate('/signin'), 3000)
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Failed to reset password. The link may have expired.')
    } finally {
      setLoading(false)
    }
  }

  if (done) {
    return (
      <div className="forgot-page">
        <div className="forgot-wrapper">
          <div className="forgot-card forgot-success">
            <div className="forgot-success-icon">
              <CheckCircle size={48} color="#48bb78" />
            </div>
            <h2>Password reset!</h2>
            <p>Your password has been updated successfully.</p>
            <p className="forgot-hint">Redirecting you to sign in…</p>
            <Link to="/signin" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: 8 }}>
              Sign In Now
            </Link>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="forgot-page">
      <div className="forgot-wrapper">
        <div className="forgot-card">

          <div className="auth-header" style={{ textAlign: 'center', marginBottom: 28 }}>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
              <div style={{ background: 'var(--primary-navy)', borderRadius: '50%', padding: 16 }}>
                <KeyRound size={32} color="white" />
              </div>
            </div>
            <h2>Reset your password</h2>
            <p>Enter a new password for <strong>{email}</strong></p>
          </div>

          {error && <div className="auth-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">New Password</label>
              <input
                type="password"
                className="form-input"
                placeholder="At least 8 characters"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Confirm Password</label>
              <input
                type="password"
                className="form-input"
                placeholder="Repeat your password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                minLength={8}
              />
            </div>

            <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>
              {loading ? 'Resetting…' : 'Reset Password'}
            </button>
          </form>

          <p style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: 'var(--text-muted)' }}>
            Remember your password?{' '}
            <Link to="/signin" style={{ color: 'var(--primary-navy)', fontWeight: 500 }}>Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  )
}
